export default {
   Home: "/",

   Auth: {
      Login: "/login",
      ForgotPassword: "/forgot-password",
      ResetPassword: "/reset-password"
   },

   TerritorialUnits: "/territorial-units",

   DocumentTypes: "/document-types",

   Documents: {
      Start: "/documents/start",
      List: ( type_id: string | number = ":type_id" ) => `/documents/type/${ type_id }`,
   },

   MessageTemplates: "/message-templates",

   CorrespondenceWithUnits: "/correspondence-with-units",

   FileArchives: "/file-archives",

   Users: "/users",

   Analysis: "/analysis",

   PublicAnalysis: "/public/analysis"
}
